import { render, staticRenderFns } from "./PerformanceScoreSetupForm.vue?vue&type=template&id=3880da4f&scoped=true"
import script from "./PerformanceScoreSetupForm.vue?vue&type=script&lang=js"
export * from "./PerformanceScoreSetupForm.vue?vue&type=script&lang=js"
import style0 from "./PerformanceScoreSetupForm.vue?vue&type=style&index=0&id=3880da4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3880da4f",
  null
  
)

export default component.exports